/* eslint-disable */
import { Model as BaseModel } from 'vue-api-query';

export default class Model extends BaseModel {
  baseURL() {
    return process.env.API_LOCATION_;
  }

  request(config) {
    return this.$http.request(config);
  }

  stringifyOptions() {
    return {
      arrayFormat: 'indices'
    }
  }

  // Configure object-to-formadata
  formData() {
    return {
      indices: true,
      allowEmptyArrays: false,
      // nullsAsUndefineds: true,
    }
  }

}



// WEBPACK FOOTER //
// ./src/models/Model.js